import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EventData } from '../providers/event';

@Pipe({
    name: 'eventInfo'
})

export class EventInfoDataPipe implements PipeTransform {

    constructor(
        private eventData: EventData
    ) { }

    transform(entityId: string, clientId: string): Observable<any> {
        return this.eventData.getEventInfo(clientId, entityId);
    }
}


// WEBPACK FOOTER //
// ./src/pipes/event-info.pipe.ts